// frontend/src/services/api/index.js
import api from "./config";
import authAPI from "./authAPI";
import adminAPI from "./adminAPI";
import creditAPI from "./creditAPI";
import esimAPI from "./esimAPI";
import transactionAPI from "./transactionAPI"; // Add this

export {
  api as default,
  authAPI,
  adminAPI,
  creditAPI,
  esimAPI,
  transactionAPI, // Add this
};
